// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 80,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  new Swiper('.sp-swiper2', {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
  })

  $('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
  })
  let spImgList1 = [
    'https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20250507-pro1.png?v=1746604391',
    'https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20250321-img1.png?v=1742551067',
  ]
  let spImgList2 = [
    'https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20250507-pro2.png?v=1746604391',
    'https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20250321-img2.png?v=1742551068',
  ]
  let spImgList3 = [
    'https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20250315-p6.png',
    'https://cdn.shopify.com/s/files/1/0695/2445/5458/files/20250315-p7.png',
  ]
  $('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
  })
  let prods = window.product
  let price4 = prods[4].price / 100
  let comprice4 = prods[4].compare_at_price / 100
  let price5 = prods[5].price / 100
  let comprice5 = prods[5].compare_at_price / 100
  $('.box1 .sp-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    // $(this);
    // style选项

    let img0 = $('.product-part .box1 .p-img')
    let _index = $(this).index()

    img0[0].srcset = spImgList1[_index]
    img0[0].src = spImgList1[_index]
    console.log($('.product-part .box1 .p-img'))
    if (_index == 0) {
      $('.product-part .box1 .p-img').css('margin-top', '-28px')
    } else {
      $('.product-part .box1  .p-img').css('margin-top', '2px')
    }
  })
  $('.box2 .sp-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    // $(this);
    // style选项

    let img0 = $('.product-part .box2 .p-img')
    let _index = $(this).index()

    img0[0].srcset = spImgList2[_index]
    img0[0].src = spImgList2[_index]
    if (_index == 0) {
      $('.product-part .box2 .p-img').css('margin-top', '8px')
    } else {
      $('.product-part .box2  .p-img').css('margin-top', '40px')
    }
  })
  $('.box3 .sp-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    // $(this);
    // style选项

    let img0 = $('.product-part .box3 .p-img')
    let _index = $(this).index()

    img0[0].srcset = spImgList3[_index]
    img0[0].src = spImgList3[_index]
    if (_index == 0) {
      let per_price = price4.toFixed(2)
      $('.product-part .box3 .p-img').css('width', '186px')
      $('.product-part .box3 .sp-univalent span').html(per_price)
      $('.product-part .box3 #price1').html(price4)
      $('.product-part .box3 #price2').html(comprice4)
    } else {
      let per_price = (price5 / 2).toFixed(2)
      $('.product-part .box3 .p-img').css('width', '358px')
      $('.product-part .box3 .sp-univalent span').html(per_price)
      $('.product-part .box3 #price1').html(price5)
      $('.product-part .box3 #price2').html(comprice5)
    }
  })
  $('.sp-btn-style').click(function () {
    let id1 = $(this).siblings('.sp-opts').find('div.active').attr('data-id')
    let id2 = $(this).attr('data-id')
    let id = id1 ? id1 : id2
    let num = $(this).siblings('.addGroup').find('input').val()
    num == undefined ? (num = 1) : ''
    window.location.href = '/cart/' + id + ':' + num
  })

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - 255
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
